<template>
  <section class="article-page" >
    <article class="article-content" v-html="currentArticle.article"></article>
    <div @click="goToPreviousArticle" v-if="previousArticle" > <feather-icon class="navigation-link navigation-article--prev" id="article-previous" icon="play" :options="options"/></div>
    <div @click="goToNextArticle" v-if="nextArticle" ><feather-icon class="navigation-link navigation-article--next" id="article-next" icon="play"  :options="options"/> </div>
    <div id="article-close" onclick="Publish.closeArticle()"><feather-icon icon="x-circle" :options="options"/></div>
  </section>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import FeatherIcon from "./FeatherIcon.vue"


export default {
  components: {

    FeatherIcon,
  },
  computed: {
     ...mapGetters([
       "currentArticle",
       "nextArticle",
       "previousArticle"
      ]),

    options() {
      return {
        width: 25,
        height: 25,
      }
    },
  },
  methods: {
    ...mapActions([
      "goToNextArticle",
      "goToPreviousArticle"
    ])
  },
}
</script>

<style>
.article-page {
    position:fixed;
    top:48px;
    min-height: calc(100vh - 48px);
    width:80%;
    /* min-width: calc(100vw - 380px); */
    left:0px;
    overflow-y: scroll;
}

/* .article-page {
  background-color: white;
  background-size: cover;
  background-repeat: no-repeat;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;
  user-select: none;
  padding: 10px 10px 120px;
  position: relative;
  top: 45px;
  width:60%;
  min-height: calc(100vh - 45px);
} */

.article-content {
    background-color:white;
    position:absolute;
    left:0;
    right:0;
    margin:auto;
    min-height: calc(100vh - 48px);
    width:95%;
    max-width: 900px;
    padding:50px 50px;
    text-align: left;
}

h1 {
    font-size: 2.4em;
  }
  h2 {
    font-size: 2em;
  }
  h3 {
    font-size: 1.7em;
  }
  h4 {
    font-size: 1.4em;
  }
  h5 {
    font-size: 1.2em;
  }
  p {
    font-size: 1em;
  }
  li {
    font-size: 1em;
  }

.article-content>p {
  /* font-family: 'FrutigerLTPro-Light' */
}

.article-content>h1,h2,h3,h4{
  padding-bottom: 14px;
  padding-top:14px;
  text-align: center;
  /* font-family: 'FrutigerLTPro-Light' */
}

.article-content>img{
  max-width: 100%;
  display: block;
  margin-left: auto;
  margin-right: auto;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;
}

.article-content>h5{
  margin-bottom: 10px;
  margin-top:10px;
  /* font-family: 'FrutigerLTPro-Light' */
}

#article-next {
    /* position: fixed;
    right: 20px;
    top: 0;
    bottom: 0;
    margin: auto; */
    height: 50px;
}

#article-previous {
  /* position: fixed;
  left: 21%;
  top: 0;
  bottom: 0;
  margin: auto; */
  height: 50px; 
  transform: rotate(180deg);
}

.navigation-link {
  opacity: 0.5;
  transition: opacity 0.3s ease;
}

.navigation-link:hover {
  opacity: 1;
}
.navigation-link a {
  color: #111;
}

.navigation-link svg {
  fill: #fff;
}

.navigation-article--next {
  position: fixed;
  right: 21%;
  top: 50%;
  cursor: pointer;
}

.navigation-article--prev {
  position: fixed;
  left: 0px;
  top: 50%;
  cursor: pointer;
}

#article-close {
  position:fixed;
  top: 50px;
  left:10px;
  color:white;
  cursor: pointer;
}

@media (max-width: 1199px) {
  .article-content {
    padding:30px 30px;
  }
}

@media (max-width: 992px) {
  .article-content {
    padding:20px 20px 100px 20px;
  }
  h1 {
    font-size: 1.4em;
  }
  h2 {
    font-size: 1.2em;
  }
  h3 {
    font-size: 1em;
  }
  h4 {
    font-size: 1em;
  }
  h5 {
    font-size: 1em;
  }
  p {
    font-size: 0.9em;
  }
  li {
    font-size: 0.9em;
  }
  ::-webkit-scrollbar {
    width: 0px;  /* remove scrollbar space */
    background: transparent;  /* optional: just make scrollbar invisible */
}
}

@media (max-width: 768px) {
  .article-content {
    padding:10px 10px 100px 10px;
    width:100%;
    min-height: calc(100vh - 48px);
  }

  .article-page {
    width: 100%;
  }

  .navigation-article--next {
    position: fixed;
    right: 0px;
    top: 50%;
    cursor: pointer;
    display: none;
  }

  .navigation-article--prev {
    display: none;
  }
  #article-close {
    color: black;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/ArticlePage.vue